import React from 'react';
import { FadeIn } from './FadeIn';
import { Button } from './Button';
export function Purchase() {
  return <section id="compra" className="py-10 px-4 relative overflow-hidden" data-id="element-128">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-cyan-900/20 via-slate-900 to-slate-900 -z-10" data-id="element-129"></div>

      <div className="max-w-4xl mx-auto" data-id="element-130">
        {/* Final CTA Copy */}
        <FadeIn data-id="element-131">
          <div className="text-center mb-10" data-id="element-132">
            <h2 className="text-2xl md:text-3xl font-bold text-white mb-6" data-id="element-133">
              <span className="text-2xl mr-2" data-id="element-134">⏳</span> Ahora la decisión es
              tuya
            </h2>

            <div className="grid md:grid-cols-2 gap-5 max-w-2xl mx-auto mb-8" data-id="element-135">
              <div className="bg-slate-800/50 p-5 rounded-2xl border border-slate-700" data-id="element-136">
                <p className="text-slate-400 mb-3 font-medium" data-id="element-137">Podés seguir:</p>
                <ul className="space-y-2 text-left w-fit mx-auto" data-id="element-138">
                  <li className="text-sm md:text-base text-slate-300 flex items-center" data-id="element-139">
                    <span className="text-red-500 mr-2" data-id="element-140">❌</span> Dudando
                  </li>
                  <li className="text-sm md:text-base text-slate-300 flex items-center" data-id="element-141">
                    <span className="text-red-500 mr-2" data-id="element-142">❌</span> Copiando
                  </li>
                  <li className="text-sm md:text-base text-slate-300 flex items-center" data-id="element-143">
                    <span className="text-red-500 mr-2" data-id="element-144">❌</span> Improvisando
                  </li>
                </ul>
              </div>

              <div className="bg-gradient-to-br from-cyan-900/40 to-blue-900/40 p-5 rounded-2xl border border-cyan-500/50 shadow-lg shadow-cyan-500/10" data-id="element-145">
                <p className="text-cyan-400 mb-3 font-medium" data-id="element-146">
                  O podés empezar a:
                </p>
                <div className="flex items-center justify-center h-full pb-4" data-id="element-147">
                  <p className="text-lg md:text-xl text-white font-bold" data-id="element-148">
                    <span className="text-lime-400 mr-2" data-id="element-149">👉</span> Pensar como
                    un profesional
                  </p>
                </div>
              </div>
            </div>
          </div>
        </FadeIn>

        {/* Pricing Card */}
        <FadeIn delay={0.2} data-id="element-150">
          <div className="bg-slate-800 rounded-3xl border-2 border-cyan-500 p-6 md:p-10 text-center relative shadow-2xl shadow-cyan-500/20 max-w-2xl mx-auto" data-id="element-151">
            <div className="absolute top-0 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-cyan-500 text-slate-900 font-bold px-5 py-2 rounded-full text-xs md:text-sm uppercase tracking-wider shadow-lg" data-id="element-152">
              Oferta Especial
            </div>

            <h3 className="text-2xl md:text-3xl font-black text-white mb-2" data-id="element-153">
              <span className="text-2xl mr-2" data-id="element-154">🚀</span> Accedé ahora a
              KinesioTapingPro
            </h3>
            <p className="text-sm md:text-base text-slate-300 mb-6" data-id="element-155">
              Y empezá a aplicar KinesioTaping con lógica, seguridad y criterio
              real.
            </p>

            <div className="flex flex-col md:flex-row items-center justify-center gap-6 mb-8" data-id="element-156">
              <div className="w-40 hidden md:block" data-id="element-157">
                <img src="https://cdn.magicpatterns.com/uploads/r5JbimjLC8x2tr2H25To9B/freepik_adaptame-la-foto-img2-a-m_2794129050-removebg-preview.png" alt="KinesioTapingPro" className="w-full h-auto rounded-lg shadow-xl transform -rotate-6" data-id="element-158" />
              </div>

              <div className="text-center md:text-left" data-id="element-159">
                <div className="text-slate-400 text-lg md:text-xl line-through mb-1 font-medium" data-id="element-160">
                  $47.990 ARS
                </div>
                <div className="text-4xl md:text-5xl font-black text-white mb-2 flex items-start justify-center md:justify-start" data-id="element-161">
                  <span className="text-2xl mt-2 mr-1 text-cyan-400" data-id="element-162">$</span>
                  19.990{' '}
                  <span className="text-lg mt-auto mb-2 ml-2 text-slate-400 font-medium" data-id="element-163">
                    ARS
                  </span>
                </div>
                <div className="text-lime-400 font-semibold text-sm mb-4" data-id="element-164">
                  + 5 Bonos Gratis Incluidos
                </div>
              </div>
            </div>

            <div className="space-y-3 mb-6" data-id="element-165">
              <Button href="https://checkout.EbookPoint.shop/cart/59363857793105:1" isExternal={true} className="w-full text-lg md:text-xl py-5 shadow-cyan-500/50 animate-pulse-slow" data-id="element-166">
                Entrar ahora y descubrir el sistema
              </Button>

              <div className="flex items-center justify-center gap-2 text-slate-400 text-xs md:text-sm" data-id="element-167">
                <svg className="w-4 h-4 text-green-500" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-168">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" data-id="element-169"></path>
                </svg>
                Pago 100% Seguro y Encriptado
              </div>
            </div>

            <div className="space-y-2 text-left bg-slate-900/50 p-5 rounded-xl border border-slate-700" data-id="element-170">
              <p className="text-sm md:text-base text-white font-medium flex items-center" data-id="element-171">
                <span className="text-cyan-400 mr-2" data-id="element-172">👉</span> Accede a una guia
                con +500 paginas de contenido
              </p>
              <p className="text-sm md:text-base text-white font-medium flex items-center" data-id="element-173">
                <span className="text-cyan-400 mr-2" data-id="element-174">👉</span> Toma accion y
                convertite en el profesional que mereces ser con esta guia de
                estudio
              </p>
            </div>

            <p className="text-slate-500 text-xs md:text-sm mt-5" data-id="element-175">
              Acceso inmediato al libro digital (PDF) y los bonos tras la
              compra.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}